import Close from '@/assets/icons/close.svg';

interface FunnelModalTitleProps {
  title: string;
  titleClass?: string;
  closeModal?: () => void;
}

const FunnelModalTitle: React.FC<FunnelModalTitleProps> = ({ title, titleClass, closeModal }) => {
  return (
    <div className="flex justify-between items-center">
      <h2 className={`text-subtitle-sm hover:cursor-pointer ${titleClass}`}>{title}</h2>
      {closeModal && (
        <img
          onClick={closeModal}
          src={Close}
          alt="Close Icon"
          className="hover:cursor-pointer w-[12px] h-[12px]"
        />
      )}
    </div>
  );
};

export default FunnelModalTitle;
